import React, { ReactNode, useState } from 'react';

import { createPortal } from 'react-dom';

import { useI18n } from 'Hooks';

import QuestionModal from '../QuestionModal';
import { Background, Container, Wrapper } from './styles';

export interface Props {
  isOpen: boolean;
  children: ReactNode;
  closeModal: () => void;
  showUnsavedChangesQuestionModal?: boolean;
}

const SideModal = ({
  isOpen,
  closeModal,
  children,
  showUnsavedChangesQuestionModal = false,
}: Props) => {
  const { t } = useI18n();
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [closeAnimation, setCloseAnimation] = useState(false);

  const handleClose = () => {
    setShowQuestionModal(false);
    setCloseAnimation(true);
    setTimeout(() => {
      setCloseAnimation(false);
      closeModal();
    }, 300);
  };

  return isOpen || closeAnimation
    ? createPortal(
        <Wrapper id="side-modal">
          <Background
            isClosing={closeAnimation}
            onClick={
              showUnsavedChangesQuestionModal
                ? () => setShowQuestionModal(true)
                : () => handleClose()
            }
          />
          <Container isClosing={closeAnimation}>{children}</Container>
          <QuestionModal
            question={t('PIM.CloseSideModalConfirmation')}
            isShowing={showQuestionModal}
            onLeftClick={handleClose}
            onRightClick={() => setShowQuestionModal(false)}
            leftStyle="Warning"
            rightStyle="OK"
          />
        </Wrapper>,
        document.body,
      )
    : null;
};

export default SideModal;
